import * as _ from 'underscore';
import { call, put } from 'redux-saga/effects';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { HostedStackedElementContainer } from '@tableau/widgets';
import { OpenWorkbookInDesktopDialogContent } from '@tableau/open-workbook-in-desktop-dialog-content';
import { OpenWorkbookDialogContentProps } from '@tableau/open-workbook-in-desktop-dialog-content/lib/src/DialogContent';
export function* handleOpenWorkbookInDesktop() {
  try {
  yield call(renderDialog);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnableToLaunchOpenInDesktopDialog()));
  }
}

export async function renderDialog(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    // TFSID: 1197869
    // TODO: find luids in workbookInfo in vpc and add unit tests for this file
    // TODO: find luids and host and site in vpc
    const dummyProps: OpenWorkbookDialogContentProps = {
      workbookInfo: {
        workbookLuid: '76836569-8106-4390-8b4e-06c6b2c2152d',
        serverHost: 'https://qa-near/',
        site: '',
      },
      isServer: true,
      updateWorkbook: () => { /*Do nothing for vizportal*/}
    };
    const dialog = React.createElement(OpenWorkbookInDesktopDialogContent, dummyProps);
    const hostContainer = new HostedStackedElementContainer();
    hostContainer.render(dialog);
  });
}
